import isEmpty from "lodash/isEmpty";
import uniq from "lodash/uniq";
import { LoadingDots } from "PFComponents/loading_dots";
import SidePanel from "PFComponents/side_panel/side_panel";
import { useActivitiesQueries } from "PFCore/hooks/queries/activities/use_activities_queries";
import { useProfile } from "PFCore/hooks/queries/profile/use_profile";
import { useIsUnbiasedMode } from "PFCore/hooks/use_is_unbiased_mode";
import { useTranslation } from "react-i18next";

import { DetailsSidePanelProps } from "../../details_panel_item";
import { ProfileDetailHeader } from "../profile_detail/profile_detail_header";
import { OverbookingsDetail } from "./overbookings_detail/overbookings_detail";

export const OverbookingsDetailSidePanel = ({
  isOnTop,
  show,
  data,
  onClose,
  zIndex,
  isClosing,
  bookingFormDetails,
  disableEntranceAnimation = false
}: DetailsSidePanelProps) => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "details.overbookings" });
  const { onEdited, onDeleted } = data.bookingDetails ?? {};
  const { goToDate } = data.bookingModuleDetails ?? {};

  const isUnbiasedModeCheck = useIsUnbiasedMode();

  const activityIds = uniq([
    ...(data.overbookingsDetails?.activityIdsContext ?? []),
    ...(data.overbookingsDetails?.filterConfig?.filteredActivityIds ?? [])
  ]);
  const { queries, isFetching: isActivitiesFetching } = useActivitiesQueries(activityIds, {
    enabled: !isEmpty(activityIds)
  });

  const isUnbiasedMode = queries.some(
    ({ data: activity }) => activity && isUnbiasedModeCheck(activity.reviewers)
  );

  const { data: profileData, isLoading: isProfileLoading } = useProfile(data?.id, {
    enabled: show && !!data?.id && !data.suspendedProfileDetails
  });

  const profile = data.suspendedProfileDetails ?? profileData;

  return (
    <SidePanel
      show={show}
      zIndex={zIndex}
      isSidePanelClosing={isClosing}
      onClose={onClose}
      title={
        !isEmpty(activityIds) && isActivitiesFetching ? (
          <LoadingDots />
        ) : (
          <ProfileDetailHeader profile={profile} subtitle={t("label")} isUnbiasedMode={isUnbiasedMode} />
        )
      }
      isOnTop={isOnTop}
      disableEntranceAnimation={disableEntranceAnimation}
    >
      <OverbookingsDetail
        profile={profile}
        isProfileLoading={isProfileLoading}
        data={data}
        onEdited={onEdited}
        onDeleted={onDeleted}
        goToDate={goToDate}
        bookingFormDetails={bookingFormDetails}
      />
    </SidePanel>
  );
};
